import script from "./Flota_PreLOP_Unidades_Nuevas_Historico.vue?vue&type=script&setup=true&lang=js"
export * from "./Flota_PreLOP_Unidades_Nuevas_Historico.vue?vue&type=script&setup=true&lang=js"

import "./Flota_PreLOP_Unidades_Nuevas_Historico.vue?vue&type=style&index=0&id=a243c38c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a243c38c"]])

export default __exports__